/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, string, object, bool, array, func } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import { createUrl } from 'utils/urlHelper';

import {
  CREATE_JOB_SUCCESS,
  CREATE_JOB_FAILURE,
  createJob as createJobAction,
} from 'actions/job';

import { makeCreateJobForm } from 'selectors/createJobForm';

import Form from 'components/Form/Form';
import ModalWrapper from 'components/ModalWrapper/ModalWrapper';

import styles from './job-create.scss';

/**
 * This is the JobCreate component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 * @author Niklas Rosdahl <niklas.rosdahl@vntrs.com>
 */
export class JobCreate extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    auth: shape({
      token: string.isRequired,
    }).isRequired,
    jobForm: shape({
      fieldsets: array.isRequired,
      validationMessages: object.isRequired,
      submitText: string.isRequired,
      sending: bool.isRequired,
      errors: object.isRequired,
    }).isRequired,
    history: object.isRequired,
    createJob: func,
    onClose: func,
    blockNavigation: bool,
  };

  static defaultProps = {
    createJob: () => {},
    onClose: () => {},
    blockNavigation: false,
  };

  createJob = data => {
    const {
      auth: { token },
      history,
      createJob,
      blockNavigation,
      onClose,
    } = this.props;

    createJob(token, data).then(({ type, payload }) => {
      if (type === CREATE_JOB_SUCCESS) {
        if (blockNavigation) {
          onClose(true);
        } else {
          // Go to job page.
          history.push(createUrl('job', payload.job_id));
        }
      }

      if (type === CREATE_JOB_FAILURE) {
        console.log('ERROR', payload);
      }
    });
  };

  /**
   * Render CreateJobs.
   *
   * @return {Object}
   */
  render() {
    const { onClose, jobForm } = this.props;

    return (
      <ModalWrapper hideModal={onClose}>
        <section className={styles.wrapper}>
          <div className={styles.row}>
            <div className={styles.content}>
              <header className={styles.header}>
                <h1 className={styles.title}>{p.t('jobs.create.title')}</h1>
                <p>{p.t('jobs.create.description')}</p>
              </header>
              <div className={styles.form}>
                <Form {...jobForm} light={true} onSubmit={this.createJob} />
              </div>
            </div>
          </div>
        </section>
      </ModalWrapper>
    );
  }
}

/**
 * Map state from redux store to props.
 */
const makeMapStateToProps = () => {
  const createJobForm = makeCreateJobForm();

  const mapStateToProps = (state, props) => {
    return {
      auth: state.auth,
      jobForm: createJobForm(state, props),
    };
  };
  return mapStateToProps;
};

export default withRouter(
  connect(makeMapStateToProps, {
    createJob: createJobAction,
  })(JobCreate)
);
